import { DirectiveBinding } from 'vue'

interface El extends Element {
  clickOutsideEvent: (e: Event) => void
}

export default {
  beforeMount(el: El, binding: DirectiveBinding) {
    el.clickOutsideEvent = function (event: Event) {
      const isPopover =
        (event.target as Node)?.parentNode instanceof Node &&
        (event.target as HTMLElement)?.parentElement?.classList.contains(
          'el-popconfirm__action'
        )

      const isDialog = (event.target as HTMLElement).closest('.el-dialog')

      if (
        document.body.contains(event.target as Node) &&
        !isPopover &&
        !(el === event.target || el.contains(event.target as Node)) &&
        !isDialog
      ) {
        binding.value(event, el)
      }
    }

    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el: El) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
}
